import React from 'react';
import PropTypes from 'prop-types';

import { responsiveBreakpoints } from 'utils/utils';

import {
  Box,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { validHexCode } from 'utils/utils';

const ProductViewSummary = ({ summaryData }) => {
  const { mobile } = responsiveBreakpoints();
  return (
    <Box
      sx={[
        {
          height: '100%',
          overflow: 'scroll',
          paddingRight: '30px',
        },
        mobile ? { height: '230px' } : null,
      ]}
    >
      <Typography variant='h2'>{summaryData?.camera_angle_name}</Typography>
      <Stack spacing={2}>
        {summaryData?.sub_sections?.map((part, i) => (
          <Box
            key={i}
            sx={{ display: 'flex', rowGap: '4px', flexDirection: 'column' }}
          >
            <Typography variant='h2'>{part?.label}</Typography>
            <TableContainer>
              <TableBody>
                {part?.data?.map((item, j) => (
                  <TableRow key={j}>
                    <TableCell
                      sx={{
                        border: 'none',
                        fontSize: '12px',
                        color: '#8E8E8E',
                        padding: '0px',
                        width: '150px',
                        lineHeight: '24px',

                        whiteSpace: 'wrap',
                        wordBreak: 'break-word',
                      }}
                    >
                      {item?.label}
                    </TableCell>
                    {item?.is_url ? (
                      <TableCell
                        sx={{
                          border: 'none',
                          fontSize: '12px',
                          color: '#000000',
                          padding: '0px',
                          whiteSpace: 'wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        <a
                          href={item?.value}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {item?.value.split('/').pop().split('_').pop()}
                        </a>
                      </TableCell>
                    ) : item?.is_pattern ? (
                      <TableCell
                        sx={{
                          border: 'none',
                          fontSize: '12px',
                          color: '#000000',
                          padding: '0px',
                          whiteSpace: 'wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        <Stack direction='row' spacing={1} alignItems='center'>
                          <a
                            href={item?.pattern_url}
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            {item?.pattern_name}
                          </a>
                          <img
                            src={item?.pattern_name}
                            style={{
                              width: '18px',
                              height: '18px',
                              objectFit: 'contain',
                            }}
                          />
                        </Stack>
                      </TableCell>
                    ) : (
                      <TableCell
                        sx={{
                          border: 'none',
                          fontSize: '12px',
                          color: '#000000',
                          padding: '0px',
                          whiteSpace: 'wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {validHexCode(item?.value) ? (
                          <Box
                            sx={{
                              width: '13px',
                              height: '13px',
                              backgroundColor: item?.value,
                              display: 'inline-block',
                              marginRight: '4px',
                              border: '0.7px solid var(--primary-border-color)',
                            }}
                          />
                        ) : null}
                        {item?.value}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </TableContainer>
            {part?.designAreaDetails?.length > 0 ? (
              <Stack spacing={1}>
                <Box
                  sx={{
                    height: '25px',
                    backgroundColor: '#EFFAFF',
                    border: '1px solid #CEEEFF',
                    borderRadius: '4px',
                    width: 'fit-content',
                    padding: '0px 12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    variant='body1'
                    sx={{ color: '#006AA2', fontWeight: '700' }}
                  >
                    Design Area Details
                  </Typography>
                </Box>
                {part?.designAreaDetails?.map((area, i) => {
                  return (
                    <Accordion
                      key={area?.name}
                      sx={{
                        boxShadow: 'none', // removes shadow (elevation)
                        '&.Mui-expanded': {
                          margin: '8px 0px 0px 0px', // remove the default extra margin when expanded
                          border: '1px solid #E5E5E5',
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls='panel1a-content'
                        id='panel1a-header'
                        sx={{
                          backgroundColor: '#F5F5F5',
                          minHeight: '36px !important', // force height
                          '&.Mui-expanded': {
                            minHeight: '36px', // keep same height when expanded
                          },
                          '& .MuiAccordionSummary-content': {
                            margin: 0, // remove extra margin
                          },
                          '& .MuiAccordionSummary-content.Mui-expanded': {
                            margin: 0, // keep consistent when expanded
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            color: '#000000',
                            fontSize: '12px',
                            fontWeight: '500',
                          }}
                        >
                          Area {i + 1}: {area?.areaName}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Box
                          sx={{
                            padding: '8px 0px',
                            borderBottom: area?.imageData?.length
                              ? '1px solid #E5E5E5'
                              : 'none',
                          }}
                        >
                          {area?.data?.length > 0 ? (
                            <TableContainer>
                              <TableBody>
                                {area?.data?.map((item, j) => {
                                  const isLink =
                                    typeof item.value === 'string' &&
                                    item.value.startsWith('https://');
                                  return (
                                    <TableRow key={j}>
                                      <TableCell
                                        sx={{
                                          border: 'none',
                                          fontSize: '12px',
                                          color: '#8E8E8E',
                                          padding: '0px',
                                          width: '150px',
                                          lineHeight: '24px',

                                          whiteSpace: 'wrap',
                                          wordBreak: 'break-word',
                                        }}
                                      >
                                        {item?.label}
                                      </TableCell>
                                      {isLink ? (
                                        <TableCell
                                          sx={{
                                            border: 'none',
                                            fontSize: '12px',
                                            color: '#000000',
                                            padding: '0px',
                                            whiteSpace: 'wrap',
                                            wordBreak: 'break-word',
                                          }}
                                        >
                                          <a
                                            href={item?.value}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                          >
                                            {item?.value
                                              .split('/')
                                              .pop()
                                              .split('_')
                                              .pop()}
                                          </a>
                                        </TableCell>
                                      ) : item?.is_pattern ? (
                                        <TableCell
                                          sx={{
                                            border: 'none',
                                            fontSize: '12px',
                                            color: '#000000',
                                            padding: '0px',
                                            whiteSpace: 'wrap',
                                            wordBreak: 'break-word',
                                          }}
                                        >
                                          <Stack
                                            direction='row'
                                            spacing={1}
                                            alignItems='center'
                                          >
                                            <a
                                              href={item?.pattern_url}
                                              target='_blank'
                                              rel='noopener noreferrer'
                                            >
                                              {item?.pattern_name}
                                            </a>
                                            <img
                                              src={item?.pattern_name}
                                              style={{
                                                width: '18px',
                                                height: '18px',
                                                objectFit: 'contain',
                                              }}
                                            />
                                          </Stack>
                                        </TableCell>
                                      ) : (
                                        <TableCell
                                          sx={{
                                            border: 'none',
                                            fontSize: '12px',
                                            color: '#000000',
                                            padding: '0px',
                                            whiteSpace: 'wrap',
                                            wordBreak: 'break-word',
                                          }}
                                        >
                                          {validHexCode(item?.value) ? (
                                            <Box
                                              sx={{
                                                width: '13px',
                                                height: '13px',
                                                backgroundColor: item?.value,
                                                display: 'inline-block',
                                                marginRight: '4px',
                                                border:
                                                  '0.7px solid var(--primary-border-color)',
                                              }}
                                            />
                                          ) : null}
                                          {item?.value}
                                        </TableCell>
                                      )}
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </TableContainer>
                          ) : null}
                        </Box>
                        <Box
                          sx={{
                            padding: '8px 0px',
                            borderBottom: area?.textData?.length
                              ? '1px solid #E5E5E5'
                              : 'none',
                          }}
                        >
                          {area?.imageData?.length > 0 ? (
                            <TableContainer>
                              <TableBody>
                                {area?.imageData?.map((item, j) => {
                                  const isLink =
                                    typeof item.value === 'string' &&
                                    item.value.startsWith('https://');
                                  return (
                                    <TableRow key={j}>
                                      <TableCell
                                        sx={{
                                          border: 'none',
                                          fontSize: '12px',
                                          color: '#8E8E8E',
                                          padding: '0px',
                                          width: '150px',
                                          lineHeight: '24px',

                                          whiteSpace: 'wrap',
                                          wordBreak: 'break-word',
                                        }}
                                      >
                                        {item?.label}
                                      </TableCell>
                                      {isLink ? (
                                        <TableCell
                                          sx={{
                                            border: 'none',
                                            fontSize: '12px',
                                            color: '#000000',
                                            padding: '0px',
                                            whiteSpace: 'wrap',
                                            wordBreak: 'break-word',
                                          }}
                                        >
                                          <a
                                            href={item?.value}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                          >
                                            {item?.value
                                              .split('/')
                                              .pop()
                                              .split('_')
                                              .pop()}
                                          </a>
                                        </TableCell>
                                      ) : item?.is_pattern ? (
                                        <TableCell
                                          sx={{
                                            border: 'none',
                                            fontSize: '12px',
                                            color: '#000000',
                                            padding: '0px',
                                            whiteSpace: 'wrap',
                                            wordBreak: 'break-word',
                                          }}
                                        >
                                          <Stack
                                            direction='row'
                                            spacing={1}
                                            alignItems='center'
                                          >
                                            <a
                                              href={item?.pattern_url}
                                              target='_blank'
                                              rel='noopener noreferrer'
                                            >
                                              {item?.pattern_name}
                                            </a>
                                            <img
                                              src={item?.pattern_name}
                                              style={{
                                                width: '18px',
                                                height: '18px',
                                                objectFit: 'contain',
                                              }}
                                            />
                                          </Stack>
                                        </TableCell>
                                      ) : (
                                        <TableCell
                                          sx={{
                                            border: 'none',
                                            fontSize: '12px',
                                            color: '#000000',
                                            padding: '0px',
                                            whiteSpace: 'wrap',
                                            wordBreak: 'break-word',
                                          }}
                                        >
                                          {validHexCode(item?.value) ? (
                                            <Box
                                              sx={{
                                                width: '13px',
                                                height: '13px',
                                                backgroundColor: item?.value,
                                                display: 'inline-block',
                                                marginRight: '4px',
                                                border:
                                                  '0.7px solid var(--primary-border-color)',
                                              }}
                                            />
                                          ) : null}
                                          {item?.value}
                                        </TableCell>
                                      )}
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </TableContainer>
                          ) : null}
                        </Box>
                        <Box
                          sx={{
                            padding: '8px 0px',
                          }}
                        >
                          {area?.textData?.length > 0 ? (
                            <TableContainer>
                              <TableBody>
                                {area?.textData?.map((item, j) => (
                                  <TableRow key={j}>
                                    <TableCell
                                      sx={{
                                        border: 'none',
                                        fontSize: '12px',
                                        color: '#8E8E8E',
                                        padding: '0px',
                                        width: '150px',
                                        lineHeight: '24px',

                                        whiteSpace: 'wrap',
                                        wordBreak: 'break-word',
                                      }}
                                    >
                                      {item?.label}
                                    </TableCell>
                                    {item?.is_url ? (
                                      <TableCell
                                        sx={{
                                          border: 'none',
                                          fontSize: '12px',
                                          color: '#000000',
                                          padding: '0px',
                                          whiteSpace: 'wrap',
                                          wordBreak: 'break-word',
                                        }}
                                      >
                                        <a
                                          href={item?.value}
                                          target='_blank'
                                          rel='noopener noreferrer'
                                        >
                                          {item?.value
                                            .split('/')
                                            .pop()
                                            .split('_')
                                            .pop()}
                                        </a>
                                      </TableCell>
                                    ) : item?.is_pattern ? (
                                      <TableCell
                                        sx={{
                                          border: 'none',
                                          fontSize: '12px',
                                          color: '#000000',
                                          padding: '0px',
                                          whiteSpace: 'wrap',
                                          wordBreak: 'break-word',
                                        }}
                                      >
                                        <Stack
                                          direction='row'
                                          spacing={1}
                                          alignItems='center'
                                        >
                                          <a
                                            href={item?.pattern_url}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                          >
                                            {item?.pattern_name}
                                          </a>
                                          <img
                                            src={item?.pattern_name}
                                            style={{
                                              width: '18px',
                                              height: '18px',
                                              objectFit: 'contain',
                                            }}
                                          />
                                        </Stack>
                                      </TableCell>
                                    ) : (
                                      <TableCell
                                        sx={{
                                          border: 'none',
                                          fontSize: '12px',
                                          color: '#000000',
                                          padding: '0px',
                                          whiteSpace: 'wrap',
                                          wordBreak: 'break-word',
                                        }}
                                      >
                                        {validHexCode(item?.value) ? (
                                          <Box
                                            sx={{
                                              width: '13px',
                                              height: '13px',
                                              backgroundColor: item?.value,
                                              display: 'inline-block',
                                              marginRight: '4px',
                                              border:
                                                '0.7px solid var(--primary-border-color)',
                                            }}
                                          />
                                        ) : null}
                                        {item?.value}
                                      </TableCell>
                                    )}
                                  </TableRow>
                                ))}
                              </TableBody>
                            </TableContainer>
                          ) : null}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
              </Stack>
            ) : null}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

ProductViewSummary.propTypes = {
  summaryData: PropTypes.object,
};
ProductViewSummary.defaultProps = {
  summaryData: {},
};
export default ProductViewSummary;
